<template>
  <div>

          <Chats />

  </div>

</template>
<script>
  import Chats from '../../views/messenger/Chats.vue'
  import {bus} from "../../main";
  export default {
    data () {
      return {
        tab: null,
        app_version:process.env.VUE_APP_VERSION_CODE,

      }
    },
    mounted() {
      this.check_user_in_zoodkomak()
      this.technician_login()
      Notification.requestPermission(permission => {
        if (permission === 'granted') {
          this.registerBackgroundSync()
        } else console.error("Permission was not granted.")
      })

      },
    components: {
      Chats
    },
    methods:{
      registerBackgroundSync() {
        if (!navigator.serviceWorker) {
          return console.error("Service Worker not supported")
        }

        navigator.serviceWorker.ready
          .then(registration => registration.sync.register('zoodpayam')
        )
          .then(() => console.log("Registered background sync"))
          .catch(err => console.error("Error registering background sync", err))

        navigator.serviceWorker.ready.then(registration => {
          if (registration.sync) {
            this.requestBackgroundSync()
          } else {
            // Background Sync isn't supported.
          }
        });


        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.register('firebase-messaging-sw.js')
            .then(reg => {
              console.log(`Service Worker Registration (Scope: ${reg.scope})`);
            })
            .catch(error => {
              const msg = `Service Worker Error (${error})`;
              console.error(msg);
            });
        } else {
          // happens when the app isn't served over HTTPS or if the browser doesn't support service workers
          console.warn('Service Worker not available');
        }
      },

      async  requestBackgroundSync() {
        const registration = await navigator.serviceWorker.ready;
        await registration.sync.register('zoodpayam');
      },
      technician_login () {
        var self = this
        var eddited_mobile = localStorage.getItem('zoodpayam_phone')
        var password = localStorage.getItem('zoodpayam_password')

        const send_data = {
          Phone: eddited_mobile,
          Password: password,
          OsName: 'ZoodPayam',
          AppNo: '7',
          OsVersion: '7',
          DeviceModel: 'android',
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/Activate', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('version is ', self.app_version, response.data.newVersion.VersionCode)
              if (self.app_version < response.data.newVersion.VersionCode) {
                console.log("must reload");
                // window.location.reload()
                if ('serviceWorker' in navigator) {
                  caches.keys().then(function(cacheNames) {
                    cacheNames.forEach(function(cacheName) {
                      caches.delete(cacheName);
                    });
                  });
                }
                window.location.reload(true)
              }
            } else {
              localStorage.setItem('zoodpayam_profile', '')
              localStorage.setItem('zoodpayam_phone', '')
              localStorage.setItem('zoodpayam_password', '')
              localStorage.setItem('zoodpayam_party_id', '')
              self.$router.push({ name:'login', params:{} })

              bus.$emit('show_toast', [2000, response.data.msg])
            }
          }).catch(e => {
          // this.errors.push(e);
          // bus.$emit('show_toast', [2000, e])

        })
      },

      check_user_in_zoodkomak () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        var user_name = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserName

        const send_data = {
          MobileNo: localStorage.getItem('zoodpayam_phone').replace('+98', ''),
          Pass: localStorage.getItem('zoodpayam_password'),
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://panel.zoodkomak.com/jetToken/GetToken', send_data, { show_pros:false })
          .then(response => {
            localStorage.setItem('userId2', response.data.UserId)
            // const send_data = {
            //   UserName: user_name,
            //   UserId: response.data.UserId,
            //   MobileNo: localStorage.getItem('phone'),
            //   Password: localStorage.getItem('password'),
            // }
            var formData = new FormData();
            formData.append('UserName',user_name)
            formData.append('UserId',response.data.UserId)
            formData.append('MobileNo',localStorage.getItem('zoodpayam_phone'))
            formData.append('Password',localStorage.getItem('zoodpayam_password'))
            // this.axios.post('/Register' , send_data,{
            self.axios.post('https://cp.zoodkomak.com/api/check_user_in_zoodkomak', formData, { show_pros:false })
              .then(response => {
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              // this.errors.push(e)
            })
          }).catch(e => {
          // this.errors.push(e)
        })
      },

    }
  }
</script>
